<template>
    <div class="sitebuilder-element-container"
         element="IframeComponent"
         :data-hide-desktop="!this.internal_config.showDesktop"
         :data-hide-mobile="!this.internal_config.showMobile" :id="id"

         :style="style()">

        <div class="embed-responsive embed-responsive-16by9" ref="container_iframe"
             v-bind:style="{height : height, width : width, minHeight : minHeight}">
            <iframe :width="internal_config.width" :height="internal_config.height" ref="iframe"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                    class="embed-responsive-item"
                    v-bind:style="{'border-radius': radius,border : border}">
            </iframe>
        </div>
    </div>
</template>
<script>

	import Model from './Model';
	import Resources from './Resources.vue';
	import axios from 'axios'

	export default {
		name: 'IframeComponent',
		components: {
			Model,
			Resources,
		},
		props: ['config', 'height_start', 'device', 'id', 'preview'],
		data() {
			return Model.data()
		},
		computed: {
			width() {
				return this.internal_config.width;
			},
			height() {
				return this.internal_config.height;
			},
			minHeight() {
				return this.internal_config.minHeight;
			},
			border() {
				return this.internal_config.border;
			},
			radius() {
				return this.internal_config.borderRadius;
			},
		},
		methods: {
			style() {
				let style = `left:  ${this.internal_config.left};
				  width: ${this.internal_config.width};
                     height: ${this.internal_config.height};
                     padding-top: ${this.internal_config.paddingTop};
                     padding-left: ${this.internal_config.paddingLeft};
                     padding-right: ${this.internal_config.paddingRight};
                     padding-bottom: ${this.internal_config.paddingBottom};
                     top: ${this.internal_config.top}`;
				return style;
			},
			buildIframe: function () {

				if (this.internal_config.src != '') {
					this.$refs.iframe.src = this.internal_config.src;
				} else {

					// contentIframe = res.data.content
					// let doc = this.$refs.iframe.contentWindow.document;
					// doc.open();
					// doc.write(this.internal_config.content.content);
					// doc.close();

					let contentIframe;
					axios.post('/get_iframe_content', 'iframe_id=' + this.id)
						.then(res => {
							contentIframe = res.data.content
							let doc = this.$refs.iframe.contentWindow.document;
							doc.open();
							doc.write(res.data.content);
							doc.close();
						})

				}

				if (this.internal_config.fullWidth) {
					this.$el.classList.add('full-width-element');
				} else {
					this.$el.classList.remove('full-width-element');
				}
			},
		}, mounted() {
			let device, childs, id, config;
			({device, childs, id, config} = this.$props);

			this.internal_config = config;
			this.device = device;

			if (typeof id !== 'undefined') {
				this.id = id;
			}

			Object.keys(this.props).forEach(prop => {
				if (typeof this.internal_config[prop] === 'undefined') {
					this.internal_config[prop] = this.props[prop];
				}
			});


			this.$root.$emit('applyAnimation', this, 'sitebuilder-element-container');


			this.buildIframe();
		}
	}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .vdr {
        height: auto !important;
    }

    @media (min-width: 800px) {
        .embed-responsive {
            min-height: unset !important;
        }
    }
</style>
